<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>.v-modal{
    z-index: 1000 !important;
  }</style>
